import { PARTNER_BANKS } from "@constants/partnerBanks";
import {
  FeatureFlagsQuery,
  FeatureFlagsQueryVariables,
  FeatureFlagValue,
  PartnerBankKey,
} from "@ctypes";
import { FEATURE_FLAGS } from "@graphql";
import { useQuery } from "@hooks/apollo";
import { getFeatureFlag } from "@utils";

export const useFeatureFlags = () => {
  const { data, ...rest } = useQuery<FeatureFlagsQuery, FeatureFlagsQueryVariables>(FEATURE_FLAGS);

  const isEmployerAddressDisabled = getFeatureFlag({
    featureFlags: data,
    value: FeatureFlagValue.DisableEmployerAddressOccupation,
  });

  // Every partner carries its own flag so each can go live on its own signature
  // date. Reading them off the registry keeps onboarding a partner to a single
  // config entry - see PD-2581.
  const partnerBankFlags = PARTNER_BANKS.reduce(
    (flags, partnerBank) => ({
      ...flags,
      [partnerBank.key]: Boolean(
        getFeatureFlag({ featureFlags: data, value: partnerBank.featureFlag }),
      ),
    }),
    {} as Record<PartnerBankKey, boolean>,
  );

  return { isEmployerAddressDisabled, partnerBankFlags, ...rest };
};
